// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";

function isActiveCampaign(start_date) {
  return Timestamp$Catalyst.isAfter(Timestamp$Catalyst.now(undefined), start_date);
}

function concatInvalidSlabs(lst, valueOpt, param) {
  var value = valueOpt !== undefined ? valueOpt : "";
  if (!lst) {
    return value;
  }
  var tail = lst.tl;
  var head = lst.hd;
  if (tail) {
    return String(head) + (", " + concatInvalidSlabs(tail, value, undefined));
  } else {
    return value + String(head);
  }
}

function getActiveCampaign(campaigns) {
  return Belt_List.keepMap(campaigns, (function (campaign) {
                if (campaign.TAG !== /* Scheduled */0) {
                  return ;
                }
                var campaign$1 = campaign.campaign;
                if (Timestamp$Catalyst.isAfter(Timestamp$Catalyst.now(undefined), campaign$1.start_date)) {
                  return [
                          campaign$1,
                          campaign.end_date
                        ];
                }
                
              }));
}

function getScheduledCampaigns(campaigns) {
  return Belt_List.keepMap(campaigns, (function (campaign) {
                if (campaign.TAG !== /* Scheduled */0) {
                  return ;
                }
                var campaign$1 = campaign.campaign;
                if (Timestamp$Catalyst.isAfter(campaign$1.start_date, Timestamp$Catalyst.now(undefined))) {
                  return [
                          campaign$1,
                          campaign.end_date
                        ];
                }
                
              }));
}

function getPendingCampaigns(campaigns) {
  return Belt_List.keepMap(campaigns, (function (campaign) {
                if (campaign.TAG === /* Pending */1) {
                  return campaign._0;
                }
                
              }));
}

function fromMinsToMiliSec(mins) {
  return Math.imul(mins, 60000);
}

function fromMilliSecToMins(mins) {
  return mins / 60000 | 0;
}

function getIntValue(value) {
  var str_opt = function (str) {
    if (str === "") {
      return ;
    } else {
      return str;
    }
  };
  return Belt_Option.mapWithDefault(str_opt(value), {
              TAG: /* Error */1,
              _0: "This is a required field"
            }, (function (str) {
                if (FormValidationUtils$Catalyst.isIntegerStringValid(str)) {
                  return {
                          TAG: /* Ok */0,
                          _0: Caml_format.caml_int_of_string(str)
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: "Please enter a valid number"
                        };
                }
              }));
}

function getWholeNumberValue(value) {
  var str_opt = function (str) {
    if (str === "") {
      return ;
    } else {
      return str;
    }
  };
  return Belt_Option.mapWithDefault(str_opt(value), {
              TAG: /* Error */1,
              _0: "This is a required field"
            }, (function (str) {
                if (!FormValidationUtils$Catalyst.isIntegerStringValid(str)) {
                  return {
                          TAG: /* Error */1,
                          _0: "Please enter a valid number"
                        };
                }
                var num = Caml_format.caml_int_of_string(str);
                if (num < 0) {
                  return {
                          TAG: /* Error */1,
                          _0: "Please enter a positive number"
                        };
                } else {
                  return {
                          TAG: /* Ok */0,
                          _0: num
                        };
                }
              }));
}

function validatePositiveFloat(value) {
  var str_opt = function (str) {
    if (str === "") {
      return ;
    } else {
      return str;
    }
  };
  return Belt_Option.mapWithDefault(str_opt(value), {
              TAG: /* Error */1,
              _0: "This is a required field"
            }, (function (str) {
                if (!FormValidationUtils$Catalyst.isFloatStringValid(str)) {
                  return {
                          TAG: /* Error */1,
                          _0: "Please enter a valid number"
                        };
                }
                var num = Number(str);
                if (num < 0.0) {
                  return {
                          TAG: /* Error */1,
                          _0: "Please enter a positive number"
                        };
                } else {
                  return {
                          TAG: /* Ok */0,
                          _0: num
                        };
                }
              }));
}

function getNameFromRole(role) {
  return role._0.first_name + (" " + role._0.last_name);
}

export {
  isActiveCampaign ,
  concatInvalidSlabs ,
  getActiveCampaign ,
  getScheduledCampaigns ,
  getPendingCampaigns ,
  fromMinsToMiliSec ,
  fromMilliSecToMins ,
  getIntValue ,
  getWholeNumberValue ,
  validatePositiveFloat ,
  getNameFromRole ,
  
}
/* Timestamp-Catalyst Not a pure module */
